import React from 'react';

import './Button.css';



const Button = ({ text, onClick, className, disable=false }) => {

  return (

    

    <button disabled={disable} className={`button ${className}`} onClick={onClick}>

      {text}

    </button>

  );

};



export default Button;